import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Link } from '@/components/links';
import { Badge } from '@/components/Badge/Badge';
import IconOfficeBuilding from '@/assets/icons/heroIcons/OfficeBuilding.svg';
import IconLocationMarker from '@/assets/icons/heroIcons/LocationMarker.svg';
import { Job } from '@/types/job';
import { LINKS } from '@/constants/links';
import { Department } from '@/sections/jobs/Department';
import { Model } from '@/sections/jobs/Model';
export const CareerBox = t0 => {
  const $ = _c(23);
  const {
    slug,
    name,
    department,
    model,
    addressShort
  } = t0;
  let t1;
  if ($[0] !== slug.current) {
    t1 = LINKS().careerDetail(slug.current ?? "");
    $[0] = slug.current;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== department) {
    t2 = department && <div className="sm:order-1"><Badge title={<Department value={department} />} className="shrink-0" /></div>;
    $[2] = department;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== name) {
    t3 = <p className="text-base font-semibold sm:order-0 lg:text-xl">{name}</p>;
    $[4] = name;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col justify-between gap-3 sm:flex-row">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== model) {
    t5 = model && <><IconLocationMarker /><span><Model value={model} /></span></>;
    $[9] = model;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p className="flex shrink-0 flex-row items-center justify-start gap-2">{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconOfficeBuilding />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== addressShort) {
    t8 = <p className="flex shrink-0 flex-row items-center justify-start gap-2">{t7}<span>{addressShort}</span></p>;
    $[14] = addressShort;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <div className="text-light-gray-500 flex flex-row flex-wrap gap-0.5 lg:justify-between lg:gap-3">{t6}{t8}</div>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t1 || $[20] !== t4 || $[21] !== t9) {
    t10 = <Link className="flex flex-col gap-3 rounded-2xl bg-white p-4 text-gray-900! no-underline! transition-colors duration-200 ease-in hover:bg-blue-50 lg:p-5 lg:pr-3 lg:pl-6" to={t1} analyticsParam="careerDetail" testId="careerDetail">{t4}{t9}</Link>;
    $[19] = t1;
    $[20] = t4;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};